import React, { useEffect } from "react";
import { Outlet } from "react-router-dom"
import { IntlProvider } from "react-intl";
import { Header } from "./components";
import { useDispatch, useSelector } from "react-redux";
import { TEAMROOM_LOCALE_TEMPLATES } from "../pages/i18n";
import { AdminUserAgent } from "../../api/adminUserAgent";
import { setCustomerAssets, setCustomerConfiguration, setInitialCustomerAssets, setInitialCustomerConfiguration, setUsersCompanyConfiguration } from "../../reducers/user";
import { useMediaQuery } from 'react-responsive';
import MobileToDesktopSplashWarning from "./components/use-desktop-splash-screen";
import { getTokenFromStorage } from "../../utils";
import { BREAKPOINTS } from "../constants";
import { InterviewNavigationGuardProvider } from "../company/interview-builder/interview-navigation-guard";

const Layout = () => {
    const dispatch = useDispatch();
    const isDesktopOrLaptop = useMediaQuery({ query: BREAKPOINTS.DESKTOP })
    const { configuration } = useSelector((state) => state.userInformationReducer);
    const uiLocale = configuration.language === "en" ? "en" : "nl";
  
    const fetchCustomerConfiguration = async () => {
      const token = getTokenFromStorage();

      if (!token) return;
      
      try {
        const { data } = await AdminUserAgent.getCustomer(token);
        dispatch(setCustomerConfiguration(data));
        dispatch(setInitialCustomerConfiguration(data));
      } catch (error) {
        console.log(error);
      }
    };
  
    useEffect(() => {
      fetchCustomerConfiguration();
    }, []);


    const fetchUsersCompanyConfig = async () => {
      const token = getTokenFromStorage();

      if (!token) return;

      try {
          const { data } = await AdminUserAgent.getCurrentCompany(token);
          dispatch(setUsersCompanyConfiguration(data));
      } catch (error) {
          console.log(error)
      }
      }

    useEffect(() => {
      fetchUsersCompanyConfig();
    }, []);

    const fetchCustomerAssets = async () => {
      const token = getTokenFromStorage();

      if (!token) return;

      try {
          const { data: customerAssets } = await AdminUserAgent.getCustomerAssets(token);
          dispatch(setCustomerAssets(customerAssets));
          dispatch(setInitialCustomerAssets(customerAssets));
      } catch (error) {
          console.log(error)
      }
      }

    useEffect(() => {
      fetchCustomerAssets();
    }, []);
    
    return (
      <IntlProvider locale={uiLocale} messages={TEAMROOM_LOCALE_TEMPLATES[uiLocale]}>
        {isDesktopOrLaptop ? (
          <div className="flow-root w-full relative bg-white min-h-screen text-left text-[1rem] text-black">
            <InterviewNavigationGuardProvider>
              <Header />
              <Outlet />
            </InterviewNavigationGuardProvider>
          </div>
        ) : (
          <MobileToDesktopSplashWarning />
        )}
      </IntlProvider>
    );
};
  
export default Layout;